import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 20px;
  padding: 0 24px;
  min-height: calc(100vh - 56px);
`

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 32px;
  border-radius: 50%;
  background-color: var(--gray100);
  padding: 18px;
`

export const MessageWrapper = styled.div`
  text-align: center;
`

export const FooterButton = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px 24px;
  background-color: var(--neutral-theme);
  z-index: 10;
`

export const RepurchaseBanner = styled.img`
  width: 100%;
  border-radius: 8px;
  margin-bottom: 8px;
`

export const RepurchaseContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const RepurchaseButtons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 8px;
`
